import Axios from 'axios';
import Cookies from 'js-cookie';

const api = Axios.create({
  baseURL: document.location.hostname.includes('eroski.es')
    ? process.env.REACT_APP_API
    : process.env.REACT_APP_API_CAPRABO,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const removeBearerToken = () => {
  // api.defaults.withCredentials = false;
  delete api.defaults.headers['X-AUTH-TOKEN'];
};

api.interceptors.request.use(
  (config) => {
    const configActive = config;
    const token = Cookies.get('token');
    if (token) {
      configActive.headers['X-AUTH-TOKEN'] = `${token}`;
    } else {
      removeBearerToken();
    }
    return configActive;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const addToken = (token) => {
  api.defaults.headers['X-AUTH-TOKEN'] = token;
};

export const routes = {
  login: '/security/get/token',
  me: '/rest/user/config/get/config',
  access: `/rest/user/header/es/get/header`,
};

export const getCookies = () => {
  return Cookies;
};

export default api;
